export const IMAGE_MAX_SIZE = 10 * 1024 * 1024
export const IMAGE_RESIZE_WIDTH = 1024

export const fmtSize = (b: number) => {
  if (b < 1024) return `${b} B`
  if (b < 1048576) return `${(b / 1024).toFixed(1)} KB`
  return `${(b / 1048576).toFixed(1)} MB`
}

/** Resize รูปให้ความกว้าง 1024px ความสูงตาม ratio (เฉพาะไฟล์รูป) */
export const resizeImageFile = (file: File): Promise<File> =>
  new Promise((resolve) => {
    if (!file.type.startsWith('image/')) {
      resolve(file)
      return
    }
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      const w = img.naturalWidth
      const h = img.naturalHeight
      if (w <= IMAGE_RESIZE_WIDTH) {
        resolve(file)
        return
      }
      const newW = IMAGE_RESIZE_WIDTH
      const newH = Math.round((h * IMAGE_RESIZE_WIDTH) / w)
      const canvas = document.createElement('canvas')
      canvas.width = newW
      canvas.height = newH
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(file)
        return
      }
      ctx.drawImage(img, 0, 0, newW, newH)
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file)
            return
          }
          const resized = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now(),
          })
          resolve(resized)
        },
        file.type,
        0.9,
      )
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(file)
    }
    img.src = url
  })

/** ดึง YouTube video ID จาก URL รูปแบบต่างๆ */
export const getYouTubeVideoId = (url: string): string | null => {
  if (!url?.trim()) return null
  const u = url.trim()
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
  ]
  for (const re of patterns) {
    const m = u.match(re)
    if (m) return m[1]
  }
  return null
}
